import { createContext, useContext, useEffect, useState, type FC, type ReactNode } from "react";

export interface PageAction {
  id: string;
  icon: FC<{ className?: string }>;
  label: string;
  onAction: () => void;
  className?: string;
  separatorBefore?: boolean;
}

interface PageActionsState {
  sectionTitle: string;
  actions: PageAction[];
}

interface PageActionsContextValue {
  state: PageActionsState | null;
  setState: (state: PageActionsState | null) => void;
}

const PageActionsContext = createContext<PageActionsContextValue>({ state: null, setState: () => {} });

export function PageActionsProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<PageActionsState | null>(null);
  return (
    <PageActionsContext.Provider value={{ state, setState }}>
      {children}
    </PageActionsContext.Provider>
  );
}

export function usePageActions() {
  return useContext(PageActionsContext).state;
}

export function useSetPageActions(sectionTitle: string, actions: PageAction[]) {
  const { setState } = useContext(PageActionsContext);
  useEffect(() => {
    setState({ sectionTitle, actions });
    return () => setState(null);
  }, [sectionTitle, actions, setState]);
}